
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#94C7FB"}}),_c('g',{attrs:{"clip-path":"url(#tw-projects-beta-icon-clip0_3901_5306)"}},[_c('path',{attrs:{"d":"M27.07 12.93l-1.41 1.41A8.014 8.014 0 0128 20c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02c-2.84.48-5 2.94-5 5.91 0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C23.55 17.9 24 18.9 24 20c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V10h-1c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z","fill":"#0B0E1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"tw-projects-beta-icon-clip0_3901_5306"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8 8)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    